// src/pages/AdminDashboard.js
import React, { useEffect, useState } from 'react';
import axios from '../utils/axiosInstance';
import { saveAs } from 'file-saver';

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [leads, setLeads] = useState([]);
  const [logs, setLogs] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  <section className="admin-tools">
  <button
    onClick={() => window.location.href = "/admin/reddit-analytics"}
    className="bg-blue-600 text-white px-4 py-2 rounded"
  >
    View Reddit Bot Analytics
  </button>
</section>

  // Fetch all admin data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [userRes, leadRes, logRes, alertRes] = await Promise.all([
          axios.get('/admin/users'),
          axios.get('/admin/leads'),
          axios.get('/admin/logs'),
          axios.get('/admin/alerts')
        ]);
        setUsers(userRes.data);
        setLeads(leadRes.data);
        setLogs(logRes.data);
        setAlerts(alertRes.data);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch admin data.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const promoteUser = async (id) => {
    try {
      await axios.post(`/admin/promote/${id}`);
      setUsers(prev => prev.map(u => u._id === id ? { ...u, admin: true } : u));
    } catch (err) {
      console.error('Promote failed:', err);
    }
  };

  const demoteUser = async (id) => {
    try {
      await axios.post(`/admin/demote/${id}`);
      setUsers(prev => prev.map(u => u._id === id ? { ...u, admin: false } : u));
    } catch (err) {
      console.error('Demote failed:', err);
    }
  };

  const exportUsersToCSV = () => {
    const csv = users.map(u => `${u.name},${u.email},${u.admin},${u.createdAt}`).join('\n');
    const blob = new Blob([`Name,Email,Admin,CreatedAt\n${csv}`], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'users.csv');
  };

  if (loading) return <div className="p-6">Loading...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-3xl font-bold">Admin Dashboard</h2>

      {/* User Table */}
      <section>
        <div className="flex justify-between items-center">
          <h3 className="text-xl font-semibold">Users</h3>
          <button onClick={exportUsersToCSV} className="bg-blue-600 text-white px-4 py-1 rounded">Export CSV</button>
        </div>
        <table className="w-full border mt-2">
          <thead>
            <tr className="bg-gray-200">
              <th className="border p-2">Name</th>
              <th className="border p-2">Email</th>
              <th className="border p-2">Created</th>
              <th className="border p-2">Admin</th>
              <th className="border p-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td className="border p-2">{user.name}</td>
                <td className="border p-2">{user.email}</td>
                <td className="border p-2">{new Date(user.createdAt).toLocaleDateString()}</td>
                <td className="border p-2">{user.admin ? '✅' : ''}</td>
                <td className="border p-2">
                  {user.admin ? (
                    <button onClick={() => demoteUser(user._id)} className="text-red-600">Demote</button>
                  ) : (
                    <button onClick={() => promoteUser(user._id)} className="text-green-600">Promote</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Leads Overview */}
      <section>
        <h3 className="text-xl font-semibold mb-2">Leads Overview</h3>
        <ul className="list-disc ml-6">
          {leads.map((lead) => (
            <li key={lead._id}>
              {lead.name} - {lead.email} ({lead.status})
            </li>
          ))}
        </ul>
      </section>

      {/* Recent Logs */}
      <section>
        <h3 className="text-xl font-semibold mb-2">Recent Activity Logs</h3>
        <ul className="list-disc ml-6">
          {logs.map((log, i) => (
            <li key={i}>{log.message} - {new Date(log.timestamp).toLocaleString()}</li>
          ))}
        </ul>
      </section>

      {/* Alerts Panel */}
      <section>
        <h3 className="text-xl font-semibold mb-2 text-red-600">System Alerts</h3>
        <ul className="list-disc ml-6">
          {alerts.map((a, i) => (
            <li key={i} className="text-red-700">{a.type.toUpperCase()}: {a.message}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default AdminDashboard;